import CargoItemFcl from "./cargo-item-fcl.component";

export default CargoItemFcl;
